import React, { useEffect } from 'react';

import { useParams } from "react-router-dom";
import usePlace from './hooks/usePlace';
import { Loader } from '@mantine/core';
import styles from './PlaceWrapper.module.css';

import Place from './Place';
import { useTranslation } from 'react-i18next';

const PlaceWrapper = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [{ place }, actions] = usePlace(t);
  const { fetch, update } = actions;

  useEffect(() => {
    fetch(id);
  }, [id]);

  if (!place) return (
    <div className={styles.loader}>
      <Loader />
    </div>
  );

  const handleSubmit = (values, vip, isSave) => {
    return update(id, values, vip, place, isSave);
  }

  return (
    <Place place={place} actions={actions} id={id} handleSubmit={handleSubmit} />
  )
}

export default PlaceWrapper;
